import { Button, Pagination, PaginationItem, PaginationProps, Stack, Typography } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { pageChanged, selectPagination, selectResultsIsLoading } from 'app/results/resultsSlice'
import { useSelector } from 'react-redux'

type ResultsGridPaginationProps = PaginationProps

const ResultsGridPagination = ({ ...props }: ResultsGridPaginationProps) => {
  const dispatch = useAppDispatch()
  const isLoading = useSelector(selectResultsIsLoading)
  const { totalPages, page, prevPage } = useSelector(selectPagination)

  const setPage = (n: number) => dispatch(pageChanged(n))

  return !isLoading && totalPages > 1 ? (
    <Stack direction="row" justifyContent="center" marginY={5} width="100%">
      <Pagination
        count={totalPages}
        page={isLoading ? prevPage : page}
        color={'secondary'}
        onChange={(_, n) => setPage(n)}
        renderItem={(itemProps) => {
          // item.

          const { page, disabled } = itemProps

          switch (itemProps.type) {
            case 'previous':
              return disabled ? null : (
                <Button onClick={() => setPage(page)} color="inherit" variant="text">
                  <Typography fontSize="inherit">PREV</Typography>
                </Button>
              )
            case 'next':
              return disabled ? null : (
                <Button onClick={() => setPage(page)} color="inherit" variant="text">
                  <Typography fontSize="inherit">NEXT</Typography>
                </Button>
              )
          }
          return <PaginationItem {...itemProps} />
        }}
      />
    </Stack>
  ) : (
    <></>
  )
}

export default ResultsGridPagination
